import {all} from 'redux-saga/effects';
import authSagas from './Auth';
import patientsSagas from './Patients';
import singlePatientSagas from './SinglePatient';
import appointmentSagas from './Appointment';
import newInterventionsSagas from './NewInterventions';
import paymentsSagas from './Payments';
import expensesSagas from './Expenses';
import dashboardSagas from './Dashboard';
import companySagas from './Company';
import profileSagas from './Profile';

export default function* rootSaga() {
  yield all([
    authSagas(),
    dashboardSagas(),
    patientsSagas(),
    singlePatientSagas(),
    appointmentSagas(),
    newInterventionsSagas(),
    paymentsSagas(),
    expensesSagas(),
    companySagas(),
    profileSagas()
  ]);
}



// WEBPACK FOOTER //
// ./sagas/index.js